import styled from "styled-components";
import FixedWeightText from "./FixedWeightText";

export const TitleText = styled(FixedWeightText)`
  font-size: 14px;
  font-weight: 500;
`
